import { Box, Card, styled } from "@mui/material";

export const Container = styled(Box)`
    color: #000;
    height  : 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    
    flex-direction: column;
`;

export const ContainerConfig = styled(Card)`
    color: #000;
    width: 100%;
    height: 100%;
    padding: 2rem;
    display: flex;
    justify-content: center;    
    flex-direction: column;
`;